import { MobiDocument } from "./MobiDocument";

export class MobiErrorLogsDocuments extends MobiDocument {
    private _id: string;
    private _rev: string;
    private listErrors: Array<any>;
    private typedoc: string;

    constructor(log: any) {
        super();
        this._id = "MobiErrorLogs";
        this.typedoc = "MobiErrorLogsDocument";
        this._rev = log._rev;
        if (typeof log.listErrors !== 'undefined' && log.listErrors.length !== 0)
            this.listErrors = log.listErrors
        else
            this.listErrors = new Array<any>();
    }


    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getListErrors(): Array<any> {
        return this.listErrors;
    }

    public setListErrors(listErrors: Array<any>): void {
        this.listErrors = listErrors;
    }

    public addNewError(date_created: string, errorIntitule: string, username: string, dateSynchro: string, localdbSize: number) {
        if (typeof this.listErrors === 'undefined' || this.listErrors.length === 0)
            this.listErrors = new Array<any>();
        let errorExist = this.listErrors.find((error: any) => error.error_intitule == errorIntitule);
        if (typeof errorExist === 'undefined')
            this.listErrors.push({
                "date_created": date_created,
                "error_intitule": errorIntitule,
                "date_synchro": dateSynchro,
                "username": username,
                "localdb_size": localdbSize 
            });
    }

    public getTypedoc(): string {
        return this.typedoc;
    }

    public setTypedoc(typedoc: string): void {
        this.typedoc = typedoc;
    }



}